import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { MasterService } from "src/app/services/master.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ApiUrls } from "src/app/services/ApiUrls";
import { AmenityModel } from "src/app/model/AmenityModel";

@Component({
  selector: "app-secure-amenity-au",
  templateUrl: "./amenity-au.component.html",
  styleUrls: ["./amenity-au.component.scss"],
})
export class AmenityAUComponent implements OnInit {
  amenityKey: number;
  pageMode: string;
  amenityModel : AmenityModel;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  amenityFileName: string;
  amenityFile: string;
  projectImagesUrl: string;
  isLoading: boolean = false;
  isPrinting: boolean = false;
  
  constructor(
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.projectImagesUrl = ApiUrls.projectImagesUrl;
      
    this.route.params.subscribe((params: Params) => {
      this.amenityKey = +params["key"];      
      if(this.amenityKey) {
        this.masterService
        .getAmenityBykey(this.amenityKey)
        .subscribe((data: any) => {
          if(data.status === 'SUCCESS') {
            this.amenityModel = data;
            this.pageMode = "Edit";
            
            this.form.patchValue({
              amenityDisplayOrder: this.amenityModel.amenityDisplayOrder,
              amenityName: this.amenityModel.amenityName
            });
            this.amenityFileName = this.amenityModel.amenityFileName;
          }
          else {
            this.masterService.errorToast(data.errorMessage);
          }
        });
      }
      else {
        this.pageMode = "Add";
      }
    });
      
    this.form = new FormGroup({
      amenityDisplayOrder: new FormControl(null, [Validators.required, Validators.min(0)]),
      amenityName: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
    });
  }

  onSubmit() {
    if (this.form.valid) {
      if(this.pageMode === 'Add') {
        if(!this.amenityFile) {
          this.errorToast('Please upload Amenity Image');
          this.isSubmitDisabled = false;
          return;
        }
        this.save();
      }
      else {
        if(!this.amenityFile) {
          if(!this.amenityFileName) {
            this.errorToast('Please upload Amenity Image');
            this.isSubmitDisabled = false;
            return;
          }
        }
        this.update();
      }
    } 
    else {
      this.isSubmitDisabled = false;
    }
  }

  async save() {
    this.masterService
    .saveAmenity({
      amenityFile: this.amenityFile,
      amenityName: this.form.value.amenityName,
      amenityDisplayOrder: this.form.value.amenityDisplayOrder
    })
    .subscribe((data: any) => {
        if(data.status === 'SUCCESS') {
          this.successToast();
          this.router.navigate(["/secure", "amenity", "list"]);
        }
        else {
          this.isSubmitDisabled = false;
          this.errorToast(data.errorMessage);
        }
      }, error => {
        this.isSubmitDisabled = false;
        console.log(error);
        this.errorToast(error.error.errorMessage, 5*1000);
      });  
  }

  async update() {
    this.masterService
    .updateAmenity(this.amenityKey, {
      amenityFile: this.amenityFile ? this.amenityFile : this.amenityFileName,
      amenityName: this.form.value.amenityName,
      amenityDisplayOrder: this.form.value.amenityDisplayOrder
    }).subscribe((data: any) => {
      if(data.status === 'SUCCESS') {
        this.successToast();
        this.router.navigate(["/secure", "amenity", "list"]);
      }
      else {
        this.isSubmitDisabled = false;
        this.errorToast(data.errorMessage);
      }
    }, error => {
      this.isSubmitDisabled = false;
      console.log(error);
      this.errorToast(error.error.errorMessage, 5*1000);
    });    
  }

  onAmenityImageSelect(event) {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      this.amenityFile = reader.result.toString();
    };
  }

  deleteAmenityImage() {
    this.amenityFile = null;
    this.amenityFileName = null;
  }

  async successToast() {
    await this._snackBar.open(
      "Amenity saved successfully.",
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }
  
}